/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { PayloadAction } from "@reduxjs/toolkit";
import { ILoginRequest, IMigration, IMigrationState } from "./types";



export const setDeviceLoginRequestAction = (state: IMigrationState, action: PayloadAction<ILoginRequest>) => {
  state.loginRequest = action.payload;
};

export const setIsConnectedAction = (state: IMigrationState, action: PayloadAction<boolean>) => {
  state.isConnected = action.payload;
};

export const setInitialMigrattionDataAction = (state: IMigrationState, action: PayloadAction<IMigration[]>) => {
  state.initialMigrationData = action.payload;
};